module.exports = __webpack_public_path__ + "static/media/resumen.a2ddf3f9.svg";